import {EVSCANNER} from "../actions/const";

const initialState = {
  resetState: false,
  showModal: false,
  isLoadingAction: false,
  isRedeemingEVoucher: false,
  isClaimingEVoucher: false,
  isUpdatingVisibility: false,
  isLoadingEVoucher: false,
  
  selectedData: null,
  formType: "",
  formId: "",
  countType: "",

  isLoading: false,
  isExporting: false,
  tableData: [],
  totalCount: 0,
  limit: 10
};

function reducer (state = initialState, action) {
  let { type, payload } = action;

  switch (type) {
    case EVSCANNER:
      if (typeof action.payload.resetState !== "undefined" && action.payload.resetState) {
        action.payload = {...initialState};
      }
      return Object.assign({}, state, action.payload);
      break;

    default:
      {
        return state;
      }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/EVScanner.js